import { motion, AnimatePresence } from "framer-motion";
import React from "react";
import { NavbarMenu } from "../../data/navData";
import { useNavigate } from "react-router-dom";

export default function HamburgerMenu({ open }) {
  const navigate = useNavigate();

  return (
    <div>
      <AnimatePresence mode="wait ">
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.3 }}
            className="absolute top-25 left-0 w-full h-screen bg-black/60  z-20"
          >
            <div className="text-xl font-semibold uppercase bg-orange-300 text-white py-10 m-6 rounded-3xl ">
              <ul className="flex flex-col justify-center items-center gap-10">
                <li>
                  <a href="/home">Home</a>
                </li>
                <li>
                  <a href="/about">About</a>
                </li>
                <li>
                  <a href="/contact">Contact</a>
                </li>
              </ul>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
